import { Link, useLocation } from "react-router";
import styled from "styled-components";

const NavContainer = styled.div`
  display: flex;
  background-color: #4a9969;
  border-radius: 24px;
  overflow: hidden;
  width: 100%;
  max-width: 500px;
`;

const TabLink = styled(Link)<{ $isActive: boolean }>`
  flex: 1;
  padding: 1rem 2rem;
  text-align: center;
  color: white;
  text-decoration: none;
  font-weight: ${(props) => (props.$isActive ? "600" : "400")};
  position: relative;
  transition: all 0.2s ease;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.15);
    opacity: ${(props) => (props.$isActive ? 1 : 0)};
    transition: opacity 0.2s ease;
    border-radius: 30px;
    margin: 5px;
  }
  &:hover::before {
    opacity: ${(props) => (props.$isActive ? 1 : 0.1)};
  }
`;

interface NavTabsProps {
  tabs: {
    label: string;
    href: string;
  }[];
  defaultActive?: string;
}

export default function NavTabs({ tabs, defaultActive }: NavTabsProps) {
  const { pathname } = useLocation();
  const hasActiveByPath = tabs.some(
    (tab) => pathname === tab.href || pathname.startsWith(`${tab.href}/`)
  );

  return (
    <NavContainer>
      {tabs.map((tab) => (
        <TabLink
          key={tab.href}
          to={tab.href}
          $isActive={
            pathname === tab.href ||
            pathname.startsWith(`${tab.href}/`) ||
            (!hasActiveByPath && defaultActive === tab.label)
          }
        >
          {tab.label}
        </TabLink>
      ))}
    </NavContainer>
  );
}